module.exports = __webpack_public_path__ + "static/assets/f9ad800b349981f5c9aef08188251f36.png";